function SearchIcon({ size = '14', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="5.6875"
        cy="5.6875"
        r="4.9375"
        stroke="#959FAF"
        strokeWidth="1.5"
      />
      <path
        d="M9.625 9.625L13.125 13.125"
        stroke="#959FAF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default SearchIcon;
